"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeSiteSettingsAPIResponse;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _immutable = require("immutable");

var _SiteSettings = _interopRequireDefault(require("./SiteSettings"));

var _constants = require("./constants");

function normalizeSiteSettingsAPIResponse(data) {
  var _fromJS;

  var bodyOverrideByDomain = data.bodyOverrideByDomain,
      allDomainsSettings = (0, _objectWithoutProperties2.default)(data, ["bodyOverrideByDomain"]);
  return (0, _immutable.fromJS)((_fromJS = {}, (0, _defineProperty2.default)(_fromJS, _constants.ALL_DOMAINS_KEY, new _SiteSettings.default(allDomainsSettings)), (0, _defineProperty2.default)(_fromJS, "byDomain", Object.keys(bodyOverrideByDomain).reduce(function (acc, domain) {
    return acc.set(domain, new _SiteSettings.default(bodyOverrideByDomain[domain]));
  }, (0, _immutable.Map)())), _fromJS));
}

module.exports = exports.default;